'use client'

import type { FC } from 'react'
import { Checkbox } from 'components/ui/checkbox'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

export const checkboxFieldConfig = {
    getInitialValue: (field: TFormField) => field.defaultValue ?? false,
    extraPropsKind: 'checkbox' as const
} satisfies Partial<import('./types').FieldTypeConfig>

const CheckboxField: FC<FieldRendererProps> = ({
    field,
    value,
    error,
    onChange,
    updatingCheckboxes,
    onCheckboxChange
}) => {
    const handleChange = (val: boolean) => {
        if (onCheckboxChange) {
            onCheckboxChange(field, val).catch(() => {})
        } else {
            onChange(field.name, val, field)
        }
    }

    const labelText = updatingCheckboxes?.[field.name]
        ? 'Updating...'
        : !!value
          ? field?.customActionTrueText || field.label
          : field?.customActionFalseText || field.label

    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <div className='flex items-center space-x-2'>
                <Checkbox
                    className='border-border'
                    id={field.name}
                    disabled={
                        !!field?.disabled ||
                        !!(
                            (field?.customCheckboxFalseAction || field?.customCheckboxTrueAction) &&
                            updatingCheckboxes?.[field.name]
                        )
                    }
                    checked={!!value}
                    onCheckedChange={(val: boolean) => handleChange(val)}
                />
                <label htmlFor={field.name} className='text-sm'>
                    {labelText}
                </label>
            </div>
        </FieldWrapper>
    )
}

export default CheckboxField
